/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const mainSectionLandingConfig = {
  mainSectionId: 'welcome',
  mainSectionTitle: '',
  mainSectionItems: [
    {
      position: 'right',
      title: 'What is a Term Plan ?',
      description: [
        "Term insurance is a straightforward form of life insurance that provides financial protection to your family against a fixed premium for a specified term. It offers a pure risk cover, meaning it focuses solely on protecting your loved ones in the event of your death. One of the advantages of term insurance is that you can obtain a substantial amount of coverage (sum assured) at affordable premiums. In case of the policyholder's demise, the nominee receives the term insurance amount, ensuring financial security for your family.",
      ],
      image: {
        link: 'https://s3.ap-south-1.amazonaws.com/io.irdai.demo/bli-cover-1-resize.png',
        name: 'term life insurance',
      },
    },
    {
      position: 'left',
      title: 'When should I buy a term plan ?',
      description: [
        'Purchasing a term plan at a younger age is beneficial due to lower premiums. Moreover, considering the current lifestyles and rising occurrences of illnesses, obtaining a term plan later in life may become challenging.',
      ],
      image: {
        name: 'issuer',
        link: 'https://s3.ap-south-1.amazonaws.com/io.irdai.demo/bli-cover-3.png',
      },
    },
    {
      position: 'right',
      title: 'How much term insurance cover do I need ?',
      description: [
        'The appropriate term insurance coverage you require is determined by your current annual income. It is recommended to obtain a term insurance cover that is 10-15 times your annual income to ensure a secure future for your family.',
        "f you have budget constraints, you have the option to opt for monthly premium payments instead of committing to a yearly payment. However, it is crucial to ensure that you have adequate term insurance coverage to safeguard your family's financial security. Using a term insurance premium calculator can assist you in selecting a coverage amount that aligns well with your budget.",
      ],
      image: {
        name: 'issuer',
        link: 'https://s3.ap-south-1.amazonaws.com/io.irdai.demo/bli-cover-2.png',
      },
    },
  ],
};
